module.exports = __webpack_public_path__ + "7c3c222535782f8bf6b6c992f6692b6c.jpg";